import { z } from 'zod';

export const passwordRule = z
  .string()
  .min(12, { message: 'Password must be at least 12 characters long.' })
  .regex(new RegExp(/^\S*$/), { message: 'Password must not contain spaces.' })
  .regex(new RegExp(/[A-Z]/), {
    message: 'Password must contain at least one uppercase letter.',
  })
  .regex(new RegExp(/[a-z]/), {
    message: 'Password must contain at least one lowercase letter.',
  })
  .regex(new RegExp(/[0-9]/), {
    message: 'Password must contain at least one number.',
  })
  .regex(new RegExp(/[^A-Za-z0-9]/), {
    message: 'Password must contain at least one special character.',
  });
